import { compareStableText } from './stable-order';

function canonical(value: unknown): unknown {
  if (value === null || typeof value === 'string' || typeof value === 'boolean') return value;
  if (typeof value === 'number') return Number.isFinite(value) ? value : String(value);
  if (Array.isArray(value)) return value.map(canonical);
  if (typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>)
        .sort(([left], [right]) => compareStableText(left, right))
        .map(([key, item]) => [key, canonical(item)]),
    );
  }
  return undefined;
}

export function stableStringify(value: unknown): string {
  return JSON.stringify(canonical(value));
}

export function checksum(value: unknown): string {
  const text = stableStringify(value);
  let primary = 2166136261;
  let secondary = 0x9e3779b9;
  for (let index = 0; index < text.length; index += 1) {
    const code = text.charCodeAt(index);
    primary = Math.imul(primary ^ code, 16777619);
    secondary = Math.imul(secondary ^ code, 2246822519);
  }
  return `${(primary >>> 0).toString(16).padStart(8, '0')}${(secondary >>> 0).toString(16).padStart(8, '0')}`;
}
